import { render, staticRenderFns } from "./DragUpload.vue?vue&type=template&id=2004ba07&scoped=true"
import script from "./DragUpload.vue?vue&type=script&lang=js"
export * from "./DragUpload.vue?vue&type=script&lang=js"
import style0 from "./DragUpload.vue?vue&type=style&index=0&id=2004ba07&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2004ba07",
  null
  
)

export default component.exports